"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var mapValue = function mapValue(options, value) {
  return options.indexOf(value) >= 0 ? value : (0, _lodash.find)(options, {
    value: value
  });
};

var Select = React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      options = _ref.options,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "primary" : _ref$variant,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["value", "options", "className", "variant", "onChange"]);

  var handleChange = function handleChange(val) {
    var value = (0, _lodash.isArray)(val) ? (0, _lodash.map)(val, 'value') : val && val.value;
    onChange && onChange(value);
  }; // react-select requires the value to be the {label, value} object, so we need to map
  // back to that for a single value, or to an array for isMulti values


  if ((0, _lodash.isArray)(value)) {
    value = (0, _lodash.map)(value, function (val) {
      return mapValue(options, val);
    });
  } else {
    value = mapValue(options, value);
  }

  return React.createElement(_reactSelect.default, _extends({}, props, {
    value: value,
    ref: ref,
    className: "Fulcrum Select variant-".concat(variant, " ").concat(className),
    classNamePrefix: 'FulcrumSelect',
    options: options,
    onChange: handleChange
  }));
});
var _default = Select;
exports.default = _default;